import { NgModule } from '@angular/core';
import { AccountCardComponent } from './containers/account-card/account-card.component';
import { AccountItemComponent } from './containers/account-item/account-item.component';
import { AccountsComponent } from './containers/accounts/accounts.component';
import { CommonModule, CurrencyPipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from 'src/assets/material/material.module';
import { LoanAccountItemComponent } from './components/loan-account-item/loan-account-item.component';
import { PaymentNotificationComponent } from './components/payment-notification/payment-notification.component';
import { AccountClosedModalComponent } from './components/account-closed-modal/account-closed-modal.component';
import { CardAccountItemComponent } from './components/card-account-item/card-account-item.component';
import { AmountDisplayComponent } from './components/amount-display/amount-display.component';
import { AccountsDollarParserComponent } from './components/dollar-parser/accounts-dollar-parser.component';
import { NotificationComponent } from '../shared/components/notification/notification.component';
import { IconCalenderComponent } from '../shared/components/icon-calender/icon-calender.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    PaymentNotificationComponent,
    AccountClosedModalComponent,
    NotificationComponent,
    MaterialModule,
    IconCalenderComponent,
  ],
  declarations: [
    AccountCardComponent,
    AccountItemComponent,
    AccountsComponent,
    LoanAccountItemComponent,
    CardAccountItemComponent,
    AmountDisplayComponent,
    AccountsDollarParserComponent,
  ],
  exports: [AccountsComponent],
  providers: [CurrencyPipe, TitleCasePipe, DecimalPipe],
})
export class AccountsModule {}
